import React from "react";
import GoogleMap from "../GoogleMap";
import LeafletMap from "../LeafletMap";
import "./Map.scss";

const Map = ({
  selectedRole,
  city,
  state,
  hospitalData,
  planExpired,
  userPlanData,
  restrictedData,
}) => {
  // Get map provider from environment variables
  // const mapProvider = process.env.REACT_APP_MAP_PROVIDER || "leaflet"; // Default to leaflet
  const mapProvider = "leaflet"; // Default to leaflet
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const leafletTileProvider =
    process.env.REACT_APP_LEAFLET_TILE_PROVIDER || "openstreetmap";

  // Render appropriate map component based on provider
  const renderMap = () => {
    switch (mapProvider.toLowerCase()) {
      case "google":
      case "googlemaps":
        if (!googleMapsApiKey) {
          console.warn(
            "Google Maps selected but no API key provided, falling back to Leaflet"
          );
          return (
            <div className="map-error">
              <div className="alert alert-warning" role="alert">
                <h6>Google Maps Configuration Required</h6>
                <p>
                  To use Google Maps, please add your API key to the environment
                  variables.
                </p>
                <small>
                  Add{" "}
                  <code>REACT_APP_GOOGLE_MAPS_API_KEY=your_api_key_here</code>{" "}
                  to your .env file
                </small>
                <hr />
                <p className="mb-0">Falling back to OpenStreetMap...</p>
              </div>
            </div>
          );
        }
        return (
          <GoogleMap
            selectedRole={selectedRole}
            city={city}
            state={state}
            hospitalData={hospitalData}
            apiKey={googleMapsApiKey}
          />
        );

      case "leaflet":
      case "openstreetmap":
      default:
        return (
          <LeafletMap
            selectedRole={selectedRole}
            city={city}
            state={state}
            hospitalData={hospitalData}
            tileProvider={leafletTileProvider}
            planExpired={planExpired}
            userPlanData={userPlanData}
            restrictedData={restrictedData}
          />
        );
    }
  };

  return (
    <div className="map-container">
      {/* <div className="map-provider-info">
        <small className="text-muted">
          Map Provider:{" "}
          {mapProvider === "google" || mapProvider === "googlemaps"
            ? "googlemaps"
            : "OpenStreetMap"}
          {mapProvider === "leaflet" &&
            leafletTileProvider !== "openstreetmap" &&
            ` (${leafletTileProvider})`}
        </small>
      </div> */}
      {renderMap()}
    </div>
  );
};

export default Map;
